/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Added a dummy class to prevent 'Account Information' popup showing
jQuery('#popupDatepicker').click(function() {
  jQuery('.ui-datepicker').addClass('popupCalendar');
});


$(window).on('load', function() {
 /* setTimeout(function(){
  $(".get-label-discount").each(function(index,item){
  
    var currencyCode=GlobalE.Currency?GlobalE.Currency:window.yCurrencyCode;
    var priceAttr=($(this).attr("data-price"))?$(this).attr("data-price"):$(this).closest('.product-item__info').find(".price--highlight").attr("data-fp");

    if (priceAttr) {
      priceAttr=priceAttr.replace(/'/g, '"').toUpperCase();
      var priceAttr = JSON.parse(priceAttr);
      if  (priceAttr.DEFAULTS && typeof (priceAttr.DEFAULTS[currencyCode]) != 'undefined') {
        var normal_price = priceAttr.DEFAULTS[currencyCode];
      }
    }
    var comparePriceAttr=($(this).attr("data-cprice"))?$(this).attr("data-cprice"):$(this).closest('.product-item__info').find(".price--compare").attr("data-fp");
    if (comparePriceAttr) {
      comparePriceAttr=comparePriceAttr.replace(/'/g, '"').toUpperCase();
      var comparePriceAttr = JSON.parse(comparePriceAttr);
      if  (comparePriceAttr.DEFAULTS && typeof (comparePriceAttr.DEFAULTS[currencyCode]) != 'undefined') {
        var comapreAt_price = comparePriceAttr.DEFAULTS[currencyCode];
      }
    }
    if(comapreAt_price && normal_price){
      var discountAmount= Math.round((comapreAt_price - normal_price) * 100 / comapreAt_price) + '%';
      var discountString=$(".product-label--on-sale").attr("data-price-settings");
      discountString= window.pricediscountSettings.replace("{{savings}}",discountAmount);
      $(this).html(discountString);
    }
  });
  },7000);
  setTimeout(function(){  
    if(window.pagename=="product"){

      var currencyCode=GlobalE.Currency?GlobalE.Currency:window.yCurrencyCode;
      var priceAttr=$('.product-form__info-list .price--highlight').attr("data-fp").replace(/'/g, '"').toUpperCase();
      if (priceAttr) {
        var priceAttr = JSON.parse(priceAttr);
        if  (priceAttr.DEFAULTS && typeof (priceAttr.DEFAULTS[currencyCode]) != 'undefined') {
          var normal_price = priceAttr.DEFAULTS[currencyCode];
        }
      }
      var comparePriceAttr=$('.product-form__info-list .price--compare').attr("data-fp").replace(/'/g, '"').toUpperCase();
      if (comparePriceAttr) {
        var comparePriceAttr = JSON.parse(comparePriceAttr);
        if  (comparePriceAttr.DEFAULTS && typeof (comparePriceAttr.DEFAULTS[currencyCode]) != 'undefined') {
          var comapreAt_price = comparePriceAttr.DEFAULTS[currencyCode];
        }
      }
      if(comapreAt_price && priceAttr){
        var discountAmount= Math.round((comapreAt_price - normal_price) * 100 / comapreAt_price) + '%';
        var discountString=$(".product-info-discount-label").attr("data-price-settings");
        discountString= discountString.replace("{{savings}}",discountAmount);
        $(".product-info-discount-label").html(discountString);
      }

    }
  },2000);*/
});
// To prevent the popup from getting disappeared
$(document).ready(function () {
   var x = setInterval(function() {
     flashDealMethod();
  }, 1000);
  if(window.pagename=="cart"){
    IsFreeGiftProduct();
  }
	jQuery.getJSON('/cart.json', function(cart) {

    var cartItems=cart.items;
    $.each(cartItems,function(index,item){
      if(item.properties!=null){
        var variant_id=item.properties['variant_id'];
        var quantity=item.quantity;
        $selector=$(".gift-checkbox-cart[data-variant_id="+variant_id+"]").closest("tr");
        $(".gift-checkbox-cart[data-variant_id="+variant_id+"]").attr("checked",true);
        var main_qty= $(".gift-checkbox-cart[data-variant_id="+variant_id+"]").closest("tr").find(".quantity-selector__value").val();
        fillGiftSelectbox($selector,main_qty);
        $selector.find('.gift-selectbox-cart').show();
        $selector.find(".gift-selectbox-cart").val(quantity);
        var url= location.href;
        var url_array=url.split("/");var url= location.href;
        var url_array=url.split("/");
        if (typeof main_qty == "undefined" && jQuery.inArray("cart", url_array)!==-1 && variant_id) {
          main_qty=0;
        }
        if(quantity>main_qty){
          removeCartItem(item.key, main_qty);
        }
      }
    });

  });
    $(document).on("click", ".popupCalendar", function () {
		$('#account-popover').attr("aria-hidden", "false");
	});

	$(document).mouseup(function(e){ 
		var container = $("#account-popover,.popupCalendar");
		// if the target of the click isn't the container nor a descendant of the container
		if (!container.is(e.target) && container.has(e.target).length === 0)
		{
			$('#account-popover').attr("aria-hidden", "true");
			$('.ui-datepicker').removeClass('popupCalendar');
		}
    });
	
	$('#giftWrap').change(function() {
    var main_qty= $("select[name='quantity'] option:selected").val();
    if (main_qty == null){
      var main_qty= $("input[name='quantity']").val();
    }
    if(this.checked && main_qty>1) {
      $('#giftbox-inside-select').show();
    }else{
      $('#giftbox-inside-select').hide();
    }
  });

  $(document).on('change',"select[name='quantity'],input[name='quantity']",function(){
    var qty=$(this).find("option:selected").val();
    if (qty == null){
      var qty= $("input[name='quantity']").val();
    }
    if($("#giftWrap").is(':checked')){
      $('#giftbox-inside-select').show();
    }else{
      $('#giftbox-inside-select').hide();
    }
    $('#giftbox-inside-select').html("");
    for(var i=1 ;i<=qty;i++){
      $('#giftbox-inside-select')
      .append($("<option></option>")
              .attr("value", i)
              .text(i)); 
    }
    $('#giftbox-inside-select').val(1);
  });

  $(document).on('change','.gift-checkbox-cart',function(){
    var $selector=$(this).closest(".line-item--stack");
    var main_qty=$selector.find(".quantity-selector__value").val();
    if(this.checked) { 
      fillGiftSelectbox($selector,main_qty);
      $selector.find('.gift-selectbox-cart').show();
    }else{
      $selector.find('.gift-selectbox-cart').hide();

    }
    updateGiftCart($(this));
  });

  $(document).on('change','.gift-selectbox-cart',function(){
    var childQty= $(this).closest("tr").find("option:selected").val();
    var variant_id=$(this).closest("tr").attr("data-variant_id");
    var line=$(".line-item__property[data-gift_product="+variant_id+"]").closest("tr").index();
    var LineRank=parseInt(line)+1;
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {
        line:LineRank,
        quantity: childQty,
      },
      dataType: 'json', 
      success: function (data) { 
        //        $(".line-item__property[data-gift_product="+variant_id+"]").closest("tr").
        location.reload();
      } 
    });
  });
  jQuery(document).on('click', '.mini-cart__quantity-remove', function (e) {
    var id=$(this).attr("data-line_id");
    var variant_id=$(this).closest(".mini-cart__line-item").attr("data-variant_id");
    var line=$(".mini-cart__property[data-gift_product="+variant_id+"]").closest(".mini-cart__line-item").index();
    if(line==-1){
      removeCartItem(id);
    }
    var LineRank=parseInt(line)+1;
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {
        line:LineRank,
        quantity: 0,
      },
      dataType: 'json', 
      success: function (data) { 
        removeCartItem(id);
      } 
    });
  });
});
 function flashDealMethod() {
    $(".flashSaleDiscountLabel").each(function(index,item){
   
    var start_time=$(this).attr("data-starttime");
    var end_time=$(this).attr("data-endtime");
    var event = new Date();
    var uktime=event.toLocaleString('en-GB', { timeZone: 'Europe/London' });
    uktime=uktime.split(",");
    //console.log("Complete Date "+uktime);
    var curr_time = get24Hr(tConvert(uktime[1].trim()));
  var start24Time=  get24Hr(tConvert(start_time));
    var end24Time=  get24Hr(tConvert(end_time));
    
    if (curr_time >= start24Time && curr_time < end24Time) {
      //in between these two times
      var splitUKDate=uktime[0].split("/");
      var newLogicDTime=splitUKDate[2]+"/"+splitUKDate[1]+"/"+splitUKDate[0];//YYYY-MM-DD
      var countDownDate = new Date(newLogicDTime+" "+end_time).getTime();
     

          // Get today's date and time
        //YYYY/mm/dd hh:mm:ss
        var newDateUkTime=splitUKDate[2]+"/"+splitUKDate[1]+"/"+splitUKDate[0]+""+uktime[1];
          var now = new Date(newDateUkTime).getTime();
        
          // Find the distance between now and the count down date
          var distance = countDownDate-now;
        
          // Time calculations for days, hours, minutes and seconds
          var days = Math.floor(distance / (1000 * 60 * 60 * 24));
          var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        
          // Display the result in the element with id="demo"
          $(this).find(".flashTimerCountDown").html(hours + "h " + minutes + "m " + seconds + "s ");
        
          // If the count down is finished, write some text
          if (distance < 0) {
           
            $(this).find(".flashTimerCountDown").html("EXPIRED");
          }
       //console.log("Test work");
      $(this).show();
    } else {
      $(this).hide();
    }
  });
  }
function tConvert(time) {
    // Check correct time format and split into components
    time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) { // If time format correct
      time = time.slice(1); // Remove full string match value
      time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join(''); // return adjusted time or original string
  }

   function get24Hr(time){
      var hours = Number(time.match(/^(\d+)/)[1]);
      var AMPM = time.match(/\s(.*)$/)[1];
      if(AMPM == "PM" && hours<12) hours = hours+12;
      if(AMPM == "AM" && hours==12) hours = hours-12;

      var minutes = Number(time.match(/:(\d+)/)[1]);
      hours = hours*100+minutes;
      //console.log(time +" - "+hours);
      return hours;
 }
// Registration popup dob and newsletter tags script
jQuery(function() {
        	jQuery('#register_newsletter').change(function() { 
         if(jQuery(this).is(":checked")) {
            var existingVal = document.getElementById("popupDatepicker").value;
           if(existingVal == '')
           { 
          	jQuery("#customer-tags").val("newsletter");
           }
           else
           {
             jQuery("#customer-tags").val("newsletter,"+existingVal);
           }
          
         }else{
           var existingVal = document.getElementById("popupDatepicker").value;
           jQuery("#customer-tags").val(existingVal); 
         }
     });
 });

// Registrationpage dob and newsletter tags script
jQuery(function() {
        	jQuery('#registerpage_newsletter').change(function() { 
         if(jQuery(this).is(":checked")) {
            var existingVal = document.getElementById("registrationDatepicker").value;
           if(existingVal == '')
           { 
          	jQuery("#newsLetterTag").val("newsletter");
           }else{
             jQuery("#newsLetterTag").val("newsletter,"+existingVal);
           }
          
         }else{
           var existingVal = document.getElementById("registrationDatepicker").value;
           jQuery("newsLetterTag").val(existingVal); 
         }
     });
 });

// checkoutpage dob and newsletter tags script
jQuery(function() {
        	jQuery('#register_newsletter_cart').change(function() { 
         if(jQuery(this).is(":checked")) {
            var existingVal = document.getElementById("cartDatepicker").value;
           if(existingVal == '')
           { 
          	jQuery("#newsLetterTagCart").val("newsletter");
           }else{
             jQuery("#newsLetterTagCart").val("newsletter,"+existingVal);
           }
          
         }else{
           var existingVal = document.getElementById("cartDatepicker").value;
           jQuery("#newsLetterTagCart").val(existingVal); 
         }
     });
 });



document.addEventListener('product:added', function(event) {
    var variant = event.detail.variant; // Get the variant that was added
    var quantity = event.detail.quantity; // Get the quantity that was added
  event.preventDefault();
   return false; //
  //alert('Qty');
 });

var divs = ["info", "orders","referal","Menu3", "Menu4"];
var visibleDivId = null;
var currentPage = window.location.href.split("#")[1];

window.location.hash = '';

if (currentPage === undefined) {
  var currentRoute = window.location.href.split("/")[3];
  if (currentRoute == 'account') {
    var currentSubRoute = window.location.href.split("/")[4];
    if (currentSubRoute == 'addresses' || currentSubRoute == 'login' || currentSubRoute == 'register') {
      currentPage = undefined;
    } else if (currentSubRoute === undefined || currentSubRoute == '') {
      currentPage = 'info';
    }
  } else {
    currentPage = undefined;
  }
} else if (currentPage == '' || currentPage == null) {
  // When there is a HASH in the URL in pages otherthan 'Account Information' Page
  var currentRoute = window.location.href.split("/")[3];
  var currentSubRoute = window.location.href.split("/")[4];
  if (currentRoute == 'account#' && currentSubRoute === undefined) {
    currentPage = 'info';
  } else  {
    currentPage = undefined;
  }
} else if (currentPage != 'orders') {
  currentPage = undefined;
} else if (currentPage == 'orders') {
  var currentSubRoute = window.location.href.split("/")[4];
  if (currentSubRoute != undefined) {
    if (currentSubRoute.includes('login')) {
     currentPage = undefined;
      }
  }
}

if (currentPage == '') {
	toggleVisibility('info');  
} else {
  if (currentPage !== undefined) {
	toggleVisibility(currentPage);
  }
}

function toggleVisibility(divId) {
  document.getElementById('account-selector').setAttribute('aria-hidden', 'false');
  visibleDivId = null;
  if(visibleDivId === divId) {
    visibleDivId = null;
  } else if (divId === undefined) {
    document.getElementById('account-selector').setAttribute('aria-hidden', 'true');
    visibleDivId = 'info';
  } else {
    visibleDivId = divId;
  }
  hideNonVisibleDivs();
}

function hideNonVisibleDivs() {
  var i, divId, div;
  for(i = 0; i < divs.length; i++) {
    divId = divs[i];
    div = document.getElementById(divId);
    var menuDiv = document.getElementById('');
    if(visibleDivId === divId) {
      var accountBreadcrumb = document.getElementById('breadcrumb__account');
      var ordersBreadcrumb = document.getElementById('breadcrumb__orders');
      var referalBreadcrumb = document.getElementById('referal__account');
      if (visibleDivId == "info") {
       accountBreadcrumb.style.display = "block";
       ordersBreadcrumb.style.display = "none";
        referalBreadcrumb.style.display = "none";
      } else if (visibleDivId == "orders") {
       accountBreadcrumb.style.display = "none";
       ordersBreadcrumb.style.display = "block";
        referalBreadcrumb.style.display = "none";
      }else if (visibleDivId == "referal") {
        accountBreadcrumb.style.display = "none";
        ordersBreadcrumb.style.display = "none";
        referalBreadcrumb.style.display = "block";
      }
      div.style.display = "block";
      document.getElementById('account-selector').setAttribute('aria-hidden', 'true');
    } else {
      if (div != null) {
        div.style.display = "none";
      }
      //div.class="card__linklist-item link";
    }
  }
  var info = [];
  var orders = [];
  var referal = [];
  info[0] = document.getElementById('account_information_item');
  orders[0] = document.getElementById('orders_item');
  referal[0] = document.getElementById('item_referal');
  info[1] = document.getElementById('account_information_value');
  orders[1] = document.getElementById('orders_value');
  referal[1] = document.getElementById('value_referal');
  
  if (visibleDivId == "info") {
    for (var i=0 ; i < info.length; i++) {
    	info[i].style.fontWeight = "bold";
    	info[i].style.color = "#000";
    }
    for (var j=0 ; j < orders.length; j++) {
    	orders[j].style.fontWeight = "normal";
    	orders[j].style.color = "#677279";
    }
    for (var v=0 ; v < referal.length; v++) {
      referal[v].style.fontWeight = "normal";
      referal[v].style.color = "#677279";
    }
  } else if (visibleDivId == "orders") {
    for (var i=0 ; i < orders.length; i++) {
    	orders[i].style.fontWeight = "bold";
    	orders[i].style.color = "#000";
    }
    for (var j=0 ; j < info.length; j++) {
    	info[j].style.fontWeight = "normal";
    	info[j].style.color = "#677279";
    }
    for (var v=0 ; v < referal.length; v++) {
      referal[v].style.fontWeight = "normal";
      referal[v].style.color = "#677279";
    }
  }else if (visibleDivId == "referal") {
    for (var i=0 ; i < referal.length; i++) {
      referal[i].style.fontWeight = "bold";
      referal[i].style.color = "#000";
    }
    for (var j=0 ; j < info.length; j++) {
      info[j].style.fontWeight = "normal";
      info[j].style.color = "#677279";
    }
    for (var v=0 ; v < orders.length; v++) {
      orders[v].style.fontWeight = "normal";
      orders[v].style.color = "#677279";
    }
  }
  visibleDivId = null;
}

// Registration Popup Datepicker method
function popupDateChange() {
  var currDate = document.getElementById('popupDatepicker').value;
  jQuery("#customer-tags").val(currDate);
}


// Registration Page Datepicker method
function registrationDateChange() {
  var currDate = document.getElementById('registrationDatepicker').value;
   jQuery("#newsLetterTag").val(currDate);
}

function cartDateChange() {
  var currDate = document.getElementById('cartDatepicker').value; 
           jQuery("#newsLetterTagCart").val(currDate);
  
  
}

function footerLinks(link) {
  var isAccountpage = window.location.href.includes('.com/account');
  if (isAccountpage) {
    if (link == '/account#orders') {
      toggleVisibility('orders');
    }
  }
}

function delete_cookie(name) {
  document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function addToCartDataLayer(el){
  var product_item = $(el).attr('data-product-item');
  if(typeof product_item == "undefined"){
    product_item = $(el).attr('data-product-data');
    product_item = $.parseJSON(product_item);
    var setPriceFormat=product_item.price;
    var  sku=product_item.variants[0].sku;
  }else{
    product_item = $.parseJSON(product_item);
    var setPriceFormat=product_item.price/100;
    var sku=product_item.variants[0].sku;
  }
  
  if(window.pagename!="cart"){
    checkFreeProductPopup(setPriceFormat,product_item.id);
  }

  var modal = document.getElementById('free-pop-choice');
  // When the user clicks on the button, open the modal 
  if(($("#free-pop-choice").attr("style").split(":")[1].trim()=="visible;")){
    modal.style.visibility = "hidden";
    modal.classList.remove("show");
  }
  
  var moneyFormat=theme.moneyFormat;
  var price= moneyFormat.replace("{{amount}}", setPriceFormat);
  var curncy = GlobalE.Currency?GlobalE.Currency:window.yCurrencyCode;
  dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
  dataLayer.push({
    event: "add_to_cart",
    ecommerce: {
      'currencyCode': curncy,
      'add': { 
        products: [{
          name: product_item.title, // Name or ID is required.
          id: product_item.id,
          price: price,
          nocurencyprice:setPriceFormat,
          brand: product_item.vendor,
          category: product_item.type,
          quantity: 1,
          sku:sku
        }]
      }
    }
  });

  if(window.location.href.indexOf("cart") >= 0)
  {
    setTimeout(function () { 
      location.reload(true);
    }, 2000);
  }
}

function onnotifyClick(el) { 
  var product_item = $(el).attr('data-product-data');
    product_item = $.parseJSON(product_item);
  dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
  dataLayer.push({
    'event': 'notifyClick',
    'ecommerce': {
      'notifyClick': {
        'products': [
         {
           name: product_item.title,
           id: product_item.id,
           sku:product_item.variants[0].sku
         }]
      }
    }
  });
}

function removeFromCartDataLayer(productData) {
  dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
  dataLayer.push({
    'event': 'removeFromCart',
    'currency' : GlobalE.Currency,
    'ecommerce': {
      'remove': {    // 'detail' actions have an optional list property.
        'products': [{         // Name or ID is required.
          'id': productData.attr('data-line_item-id'),
          'price' : productData.attr('data-line_item-price'),
          'quantity' : productData.attr('data-line_item-quantity'),

        }]
      }
    }
  });
}

function removeCartItem(id, qty=0){
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: {
      id:id,
      quantity: qty,
    },
    dataType: 'json', 
    success: function (data) { 
      location.reload();
    } 
  });
}

function updateGiftCart($selector){
  var totalGiftQtyCount=0;
  var variant_id=$selector.closest("tr").attr("data-variant_id");
  var title=$selector.closest("tr").attr("data-variant_name");
  var sku=$selector.closest("tr").attr("data-sku");
  var line=$(".line-item__property[data-gift_product="+variant_id+"]").closest("tr").index();
  var LineRank=parseInt(line)+1;
  if($selector.closest("tr").find(".gift-checkbox-cart").is(':checked')){
    var childQty= $selector.closest("tr").find("option:selected").val();
 var product_type = $selector.closest("tr").find(".gift-checkbox-cart").attr("data-variant-type");
    var new_gift_id  =  $selector.closest("tr").find(".gift-selectbox-cart").attr("data-child-id");
   
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id:new_gift_id,
        quantity:childQty,
       properties: {
          'variant_id':variant_id,
          'For': title,
          'REFSKU': sku
        }
      },
      dataType: 'json', 
      success: function (data) { 
        location.reload();
      } 
    });

  }else{
    var childQty= 0;
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {
        line:LineRank,
        quantity: childQty,
      },
      dataType: 'json', 
      success: function (data) { 
        location.reload();
      } 
    });
  }
}


function fillGiftSelectbox($selector,main_qty){
  $selector.find('.gift-selectbox-cart').html("");
  for(var i=1 ;i<=main_qty;i++){
    $selector.find('.gift-selectbox-cart')
    .append($("<option></option>")
            .attr("value", i)
            .text(i)); 
  }
  $selector.find('.gift-selectbox-cart').val(1);
}

function openPreOrderDetails(){
   // Get the modal
  var modal = document.getElementById('Mondomodel');

  // Get the <span> element that closes the modal
  var span = document.getElementsByClassName("close")[0];

  // When the user clicks on the button, open the modal 
  document.onload = setTimeout(function() {
    modal.style.display = "block";
  }, 100);

  // When the user clicks on <span> (x), close the modal
  span.onclick = function() {
    modal.style.display = "none";
  }

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  }
}

 function openGiftBoxDetails() {
    // Get the modal
  var modal = document.getElementById('giftBoxModal');

  // Get the <span> element that closes the modal
  var span = document.getElementsByClassName("close")[0];

  // When the user clicks on the button, open the modal 
  document.onload = setTimeout(function() {
    modal.style.display = "block";
  }, 100);

  // When the user clicks on <span> (x), close the modal
  span.onclick = function() {
    modal.style.display = "none";
  }

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  }
  }

$(document).on('click','.close',function(){
  $("#chaseBoxModal").hide();
  $("#giftBoxModal").hide();
  $("#free-pop-choice").hide();
  $("#Mondomodel").hide();
});
function giftBoxBtnClose() {
    var modal = document.getElementById('giftBoxModal');
    modal.style.display = "none";
  }


$(document).on('click','.openChaseBoxClick',function(e) {
  e.preventDefault();
  // Get the modal
  var modal = document.getElementById('chaseBoxModal');

  // Get the <span> element that closes the modal
  var span = document.getElementsByClassName("close")[0];

  // When the user clicks on the button, open the modal 
  document.onload = setTimeout(function() {
    modal.style.display = "block";
  }, 100);

  // When the user clicks on <span> (x), close the modal
  span.onclick = function() {
    modal.style.display = "none";
  }

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  }
  return false;
});

$(document).on('click','.openfreepopClick',function(e) {
  e.preventDefault();
  // Get the modal
  var modal = document.getElementById('free-pop-choice');

  // Get the <span> element that closes the modal
  var span = document.getElementsByClassName("close-hide")[0];

  // When the user clicks on the button, open the modal 
  document.onload = setTimeout(function() {
    modal.style.visibility = "visible";
    modal.classList.add("show");

  }, 100);

  // When the user clicks on <span> (x), close the modal
  span.onclick = function() {
    modal.style.visibility = "hidden";
    modal.classList.remove("show");
  }

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.visibility = "hidden";
      modal.classList.remove("show");
    }
  }
  //    new flickityFade(element.querySelector(".product-list-free"),{});
  //   $('.product-list-free').flickityFade();
  return false;
});

function chaseBoxBtnClose() {
  var modal = document.getElementById('chaseBoxModal');
  modal.style.display = "none";
}


// logout link
jQuery('#logOutUrl').on('click', function(event){
  event.preventDefault(); 
  var href = jQuery(this).attr("href"),
      target = '';

  delete_cookie('cart');

  // wait for data to push and then open link
  setTimeout(function() { // now wait 150 milliseconds...
      window.open(href,(!target?"_self":target)); // ...and open the link as usual
  },150);

});

jQuery.noConflict();
  setTimeout(function(){  

          jQuery('.customitems').each(function(){ 
            if(jQuery(this).data('country') != ''){
            var cntry = jQuery(this).data('country');
             //var str1 = jQuery("body").data('ctry');
            var str1 = window.Shopify.country;
             
              if(cntry.search(str1) >= 0){
              // jQuery(this).remove();
                jQuery(".product-item__action-list.button-stack", this).remove();
                jQuery( ".product-item__info-inner", this ).after( "<button class='addToCart' style='margin: 15px 0 0 0;'>Unavailable</button>" );
              console.log("Data Attr Country js = "+jQuery(this).data('country'));
              }
           
            }
          });

        },3500);

function checkFreeProductPopup(price,product_id){

  var freeProductArr=[];
  $('.freepopvalidate').each(function(){
    freeProductArr.push(jQuery(this).data('id'));
  });
  var setPriceFormat=price*100;

  jQuery.getJSON('/cart.json', function(cart) {
    var totalCartValue=cart.total_price+setPriceFormat;   
    var cartProductArr=[];
    var cartItems=cart.items;
    var allfrecokie = getCookie('allfreepop');
    var isFreeProductInCart=false;
    var isFreePriceItem=false;
    var isFreeProductNotLabel=false;
    $.each(cart.items,function(index,item){
      if(!item.discounted_price){
        isFreeProductInCart=true;
      }
    });
    cartItems.push({'product_id':product_id,'price':setPriceFormat});
    $.each(cartItems,function(index,item){
      var cart_product_id=item.product_id;
      var line_single_price=item.price;
      cartProductArr.push(item.product_id);
      if(!isFreeProductInCart){
        $.each(freeProductArr,function(index,item){
          if(cart_product_id==item){
            var netCartValue=totalCartValue-line_single_price;
            isFreeProductNotLabel=true;
            if(netCartValue>=window.freePopProductThresold){
              isFreePriceItem=true;
            }
          }
        });
      }
    });
	if(!isFreeProductNotLabel && (totalCartValue>=window.freePopProductThresold)){
      isFreePriceItem=true;
    }

    if(isFreePriceItem && !isFreeProductInCart  && allfrecokie == ''){
      $("#cart-freelabel").show();
      shwoingFreePop();
    }

  });

}
function shwoingFreePop(){
  var modal = document.getElementById('free-pop-choice');

  // When the user clicks on the button, open the modal 
  if(($("#free-pop-choice").attr("style").split(":")[1].trim()=="visible;")){
    modal.style.visibility = "hidden";
    modal.classList.remove("show");
  }else{
    document.onload = setTimeout(function() {
      modal.style.visibility = "visible";
      modal.classList.add("show");
      setCookie("allfreepop","1",1);
    }, 100);
  }
  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.visibility = "hidden";
      modal.classList.remove("show");
    }
  }
}
function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function findCommonElements3(arr1, arr2) {
  return arr1.some(item => arr2.includes(item))
}

function IsFreeGiftProduct(){
  var freeProductArr=[];
  $('.freepopvalidate').each(function(){
    freeProductArr.push(jQuery(this).data('id'));
  });




  jQuery.getJSON('/cart.json', function(cart) {
    var cartProductArr=[];
    var isFreeProductInCart=false;
    var isFreePriceItem=false;
    var totalCartValue=cart.total_price;


    $.each(cart.items,function(index,item){
      if(!item.discounted_price){
        isFreeProductInCart=true;
      }
    });

    $.each(cart.items,function(index,item){

      var cart_product_id=item.product_id;
      var line_single_price=item.price
      cartProductArr.push(item.product_id);
      if(!isFreeProductInCart){
        $.each(freeProductArr,function(index,item){
          if(cart_product_id==item){
            var netCartValue=totalCartValue-line_single_price;
            if(netCartValue>window.freePopProductThresold){
              isFreePriceItem=true;
            }
          }
        });

      }
    });

    if(isFreePriceItem){
      $("#cart-freelabel").show();
    }else{
      $("#cart-freelabel").hide();
      var isFreeProduct=findCommonElements3(freeProductArr, cartProductArr);
      if(!isFreeProduct){
        $("#cart-freelabel").show();
      }

    }
    var cartfreepop=getCookie("cartfreepop");
    var isFreeProduct=findCommonElements3(freeProductArr, cartProductArr);
    if(totalCartValue>=window.freePopProductThresold && cartfreepop== '' && !isFreeProduct){
      setCookie("cartfreepop", 1, 1)
      shwoingFreePop();
    }
  });
  /*$('<span class="free-popup-free-text"> Free</span>').insertAfter($("#free-pop-choice .price"));*/
}